export enum MapModeEnum {
  one = 'one',
  many = 'many',
  change = 'change'
}
